import Applicant from '@/views/borrows/applicants/Index'
import List from '@/views/borrows/applicants/List'
import Show from '@/views/borrows/applicants/Show'
import Edit from '@/views/borrows/applicants/Edit'
import ShowComment from '@/views/borrows/applicants/ShowComment'
import SwitchTableColumn from '@/views/borrows/applicants/SwitchTableColumn'
import Permissions from '@/permissions'

export const applicantRouters = {
  path: 'applicant',
  name: 'applicant',
  component: Applicant,
  redirect: 'applicant',
  meta: {
    permissions: [Permissions.backend.applicant.manage],
    groups: 'applicant'
  },
  children: [
    {
      path: '',
      name: 'list-applicant',
      component: List,
      meta: {
        permissions: [Permissions.backend.applicant.list],
        groups: 'applicant',
        breadcrumb: [
          {
            name_en: 'Applicant',
            name_km: 'អ្នកស្នើសុំកម្ចី'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    },
    {
      path: 'show/:id',
      name: 'show-applicant',
      component: Show,
      meta: {
        permissions: [Permissions.backend.applicant.show],
        groups: 'applicant',
        breadcrumb: [
          {
            name_en: 'Applicant',
            name_km: 'អ្នកស្នើសុំកម្ចី'
          },
          {
            name_en: 'Show',
            name_km: 'បញ្ជី'
          }
        ]
      }
    },
    {
      path: 'edit/:id',
      name: 'edit-applicant',
      component: Edit,
      meta: {
        permissions: [Permissions.backend.applicant.show],
        groups: 'applicant',
        breadcrumb: [
          {
            name_en: 'Applicant',
            name_km: 'អ្នកស្នើសុំកម្ចី'
          },
          {
            name_en: 'Edit',
            name_km: 'កែសម្រួល'
          }
        ]
      }
    },
    {
      path: 'comments/:borrow_id',
      name: 'comments-applicant',
      component: ShowComment,
      meta: {
        permissions: [Permissions.backend.applicant.show],
        groups: 'applicant',
        breadcrumb: [
          {
            name_en: 'Applicant',
            name_km: 'អ្នកស្នើសុំកម្ចី'
          },
          {
            name_en: 'Show',
            name_km: 'មើល'
          }
        ]
      }
    },
    {
      path: 'switch-table-column-applicant',
      name: 'switch-table-column-applicant',
      component: SwitchTableColumn,
      meta: {
        permissions: [Permissions.backend.applicant.filterColumnTable],
        groups: 'applicant',
        breadcrumb: [
          {
            name_en: 'Applicant',
            name_km: 'អ្នកស្នើសុំកម្ចី'
          },
          {
            name_en: 'Switching table columns',
            name_km: 'ផ្លាស់ប្តូរព័ត៌មាននៃតារាង'
          }
        ]
      }
    }
  ]
}
